import { render, staticRenderFns } from "./sallesRelational.vue?vue&type=template&id=5a8d336a&scoped=true&"
import script from "./sallesRelational.vue?vue&type=script&lang=js&"
export * from "./sallesRelational.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=5a8d336a&scoped=true&lang=css&"
import style1 from "./sallesRelational.vue?vue&type=style&index=1&id=5a8d336a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d336a",
  null
  
)

export default component.exports